import { forwardRef, type Ref, type SVGProps } from "react";
const IconHomeSimilarOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m9.05 2.218 4.625 4.333A.91.91 0 0 1 14 7.25v6.874c0 .504-.41.913-.917.913H3.917A.914.914 0 0 1 3 14.123V7.25a.91.91 0 0 1 .325-.698L7.95 2.218a.92.92 0 0 1 1.1 0" />
    <path
      fillRule="evenodd"
      d="M28.675 6.551 24.05 2.218a.92.92 0 0 0-1.1 0l-4.625 4.333A.91.91 0 0 0 18 7.25v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V7.25a.91.91 0 0 0-.325-.698M23.5 4.444l3.5 3.28v5.312h-7V7.723z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="m9.05 17.218 4.625 4.333a.91.91 0 0 1 .325.698v6.874c0 .504-.41.913-.917.913H3.917A.914.914 0 0 1 3 29.123V22.25a.91.91 0 0 1 .325-.698l4.625-4.333a.92.92 0 0 1 1.1 0M12 22.723l-3.5-3.28-3.5 3.28v5.313h7z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="m28.675 21.551-4.625-4.333a.92.92 0 0 0-1.1 0l-4.625 4.333a.91.91 0 0 0-.325.698v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V22.25a.91.91 0 0 0-.325-.698M23.5 19.444l3.5 3.28v5.312h-7v-5.313z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHomeSimilarOutlineSVG);
ForwardRef.displayName = "IconHomeSimilarOutline";
export { ForwardRef as IconHomeSimilarOutline };
